module.exports = __webpack_public_path__ + "static/media/visualizacion-logo-caracol-tv-2003-2012@3x.59c80c02.png";